import * as React from "react"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import MobileMenu from "./mobile-menu"

const menuItems = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about/" },
  { label: "Tips", to: "/tips/" },
  { label: "Contact", to: "/contact/" },
]

const Header = () => {
  return (
    <header
      className="bg-lightYellow flex flex-col w-full px-2 xl:px-0"
      style={{ boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)", zIndex: "1000" }}
    >
      <div className="flex justify-between items-center flex-1 mx-auto max-w-6xl w-full">
        <Link
          to="/"
          style={{
            fontSize: `var(--font-sm)`,
            textDecoration: `none`,
          }}
          className="font-crimson text-xl"
        >
          <div className="py-1">
            <StaticImage
              src={"../images/round-transparent.png"}
              height={110}
              placeholder="tracedSVG"
              transformOptions={{ cropFocus: "center" }}
              alt="Scott's school for dogs logo"
            />
          </div>
        </Link>

        {/* Desktop Menu */}
        <div className="hidden md:flex md:items-center">
          {menuItems.map(item => (
            <Link
              key={item.label}
              to={item.to}
              className="text-gray-600 hover:text-black font-semibold tracking-wider text-md mr-8 pb-1"
              activeClassName="text-black border-b-2 border-black"
            >
              {item.label}
            </Link>
          ))}
        </div>

        {/* Mobile Menu */}
        <MobileMenu items={menuItems} />
      </div>
    </header>
  )
}

export default Header
